import { createFeature, createReducer, on } from '@ngrx/store';
import { none, some } from '@sapphire/result';

import { AuthActions, SettingsActions } from '../actions/auth.actions';
import { AuthState } from '../auth-state.model';
import { INITIAL_COMPANY_SETTINGS } from '../auth-state.constants';

const initialState: AuthState = {
  loading: false,
  error: null,
  user: none,
  allBuyerSettings: {},
  companySettings: INITIAL_COMPANY_SETTINGS,
  failedLoginAttempts: 0,
};

export const authFeatureKey = 'auth';

export const authReducer = createReducer(
  initialState,
  // Login
  on(AuthActions.login, (state) => ({ ...state, loading: true, error: null })),
  on(AuthActions.loginSuccess, (state, { user }) => ({
    ...state,
    loading: false,
    user: some(user),
    failedLoginAttempts: 0,
    error: null,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    failedLoginAttempts: state.failedLoginAttempts + 1,
    error,
  })),
  // Logout
  on(AuthActions.logout, (state) => ({ ...state, loading: true, error: null })),
  on(AuthActions.logoutSuccess, (state) => ({
    ...state,
    loading: false,
    user: none,
    allBuyerSettings: {},
    companySettings: {},
    error: null,
  })),
  on(AuthActions.logoutFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  // Settings
  on(SettingsActions.loadSettingsSuccess, (state, settings) => ({
    ...state,
    allBuyerSettings: settings.allBuyerSettings,
    companySettings: settings.companySettings,
    error: null,
  })),
);

export const authFeature = createFeature({
  name: authFeatureKey,
  reducer: authReducer,
});
